document.addEventListener("DOMContentLoaded", function() {
    new Swiper(".guaranteeswiper",{
        slidesPerView: 4,
        spaceBetween: 20,
        loop: !0,
        pagination: {
            el: ".guaranteeswiper .swiper-pagination",
            clickable: !0
        },
        breakpoints: {
            320: {
                slidesPerView: 1
            },
            769: {
                slidesPerView: 1
            },
            1024: {
                slidesPerView: 4
            }
        }
    })
}),
document.addEventListener("DOMContentLoaded", function() {
    var el = document.querySelector(".u-reviews-swiper");
    el && new Swiper(el,{
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
            el: el.querySelector(".swiper-pagination"),
            clickable: !0
        }
    })
}),
document.addEventListener("DOMContentLoaded", function() {
    new Swiper(".announcement-swiper",{
        slidesPerView: 1,
        centeredSlides: !1,
        spaceBetween: 20,
        breakpoints: {
            768: {
                slidesPerView: 3,
                centeredSlides: !1
            }
        }
    })
}),
document.addEventListener("DOMContentLoaded", function() {
    var swiper = new Swiper(".u-image-swiper",{
        slidesPerView: 5,
        spaceBetween: 10,
        loop: !0,
        navigation: {
            nextEl: ".u-image-slider .swiper-button-next",
            prevEl: ".u-image-slider .swiper-button-prev"
        },
        breakpoints: {
            0: {
                slidesPerView: 2,
                spaceBetween: 8
            },
            888: {
                slidesPerView: 4,
                spaceBetween: 10
            },
            1e3: {
                slidesPerView: 5,
                spaceBetween: 10
            }
        }
    })
});
function toggleProductInCart(checkbox) {
    var productId = checkbox.value;
    console.log("Product ID:", productId),
    checkbox.checked ? $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
            id: productId,
            quantity: 1
        },
        dataType: "json",
        success: function(response) {
            console.log("Added to cart:", response),
            reloadDivContent("mdata-cart-total")
        },
        error: function(XMLHttpRequest, textStatus) {
            console.error("Error adding to cart:", textStatus, XMLHttpRequest.responseJSON)
        }
    }) : $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: {
            id: productId,
            quantity: 0
        },
        dataType: "json",
        success: function(response) {
            console.log("Removed from cart:", response),
            reloadDivContent("mdata-cart-total")
        },
        error: function(XMLHttpRequest, textStatus) {
            console.error("Error removing from cart:", textStatus, XMLHttpRequest.responseJSON)
        }
    })
}
function reloadDivContent(divId) {
    console.log("Reloading Div....."),
    $.get(window.location.href, function(data) {
        var newContent = $(data).find("#" + divId).html();
        $("#" + divId).html(newContent)
    }),
    console.log("Reloaded Div.....")
}
document.addEventListener("DOMContentLoaded", function() {
    document.querySelector(".product-form__add-btn")?.addEventListener("click", function() {
        setTimeout( () => {
            let shippingCheckbox = document.querySelector("#mshipping-toggle-input");
            shippingCheckbox && !shippingCheckbox.checked && (shippingCheckbox.checked = !0,
            shippingCheckbox.dispatchEvent(new Event("change",{
                bubbles: !0
            })))
        }
        , 3e3)
    })
});
//# sourceMappingURL=/cdn/shop/t/19/assets/umerzaman152.js.map?v=77438734136333741191758292997
